import React, { useState, useEffect } from 'react';

const CLASS_KEYS = {
  'tda-ml': process.env.REACT_APP_CLASS_KEY_TDA_ML,
  'python-ml': process.env.REACT_APP_CLASS_KEY_PYTHON_ML,
};

export default function ClassGate({ classId, className, children }) {
  const storageKey = `classAuth_${classId}`;
  const [unlocked, setUnlocked] = useState(false);
  const [input, setInput] = useState('');
  const [error, setError] = useState(false);

  useEffect(() => {
    if (sessionStorage.getItem(storageKey) === '1') {
      setUnlocked(true);
    }
  }, [storageKey]);

  function handleSubmit(e) {
    e.preventDefault();
    if (input === CLASS_KEYS[classId]) {
      sessionStorage.setItem(storageKey, '1');
      setUnlocked(true);
    } else {
      setError(true);
      setInput('');
    }
  }

  if (unlocked) return children;

  return (
    <div style={{
      minHeight: '60vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    }}>
      <div style={{
        background: 'var(--bg-card)',
        border: '1px solid var(--border)',
        borderRadius: 'var(--radius)',
        padding: '2.5rem 2rem',
        width: '100%',
        maxWidth: 400,
        textAlign: 'center',
      }}>
        <i className="bi bi-lock" style={{ fontSize: '2rem', color: 'var(--accent)', marginBottom: '1rem', display: 'block' }} />
        <div style={{ color: 'var(--text-muted)', fontSize: '0.8rem', textTransform: 'uppercase', letterSpacing: '0.08em', marginBottom: '0.4rem' }}>
          Acceso Restringido
        </div>
        <div style={{ fontWeight: 700, fontSize: '1.1rem', marginBottom: '2rem' }}>
          {className}
        </div>

        <form onSubmit={handleSubmit}>
          <div style={{ display: 'flex', gap: '0.5rem' }}>
            <input
              type="password"
              value={input}
              onChange={e => { setInput(e.target.value); setError(false); }}
              placeholder="Clave de acceso"
              autoFocus
              style={{
                flex: 1,
                background: 'var(--bg-secondary)',
                border: `1px solid ${error ? 'var(--danger, #e55)' : 'var(--border)'}`,
                borderRadius: 6,
                padding: '0.55rem 0.9rem',
                color: 'var(--text-primary)',
                fontSize: '0.9rem',
                outline: 'none',
              }}
            />
            <button
              type="submit"
              style={{
                background: 'var(--accent)',
                border: 'none',
                borderRadius: 6,
                padding: '0.55rem 1rem',
                color: '#fff',
                cursor: 'pointer',
                fontSize: '1rem',
                display: 'flex',
                alignItems: 'center',
              }}
            >
              <i className="bi bi-arrow-right" />
            </button>
          </div>
          {error && (
            <div style={{ color: 'var(--danger, #e55)', fontSize: '0.8rem', marginTop: '0.6rem' }}>
              Clave incorrecta. Inténtalo de nuevo.
            </div>
          )}
        </form>
      </div>
    </div>
  );
}
